export const sidebarAdminData = [
  {
    url: "/admin/dashboard/manage-categories",
    name: "Categories Management",
  },
  {
    url: "/admin/dashboard/manage-products",
    name: "Products Management",
  },
  {
    url: "/admin/dashboard/manage-orders",
    name: "View Orders",
  },
  {
    url: "/admin/dashboard/privacy-settings",
    name: "Privacy Settings",
  },
];

export const sidebarUserData = [
  {
    url: "/cart",
    name: "Cart",
  },
  {
    url: "/wishlist",
    name: "Wishlist",
  },
  {
    url: "/user/dashboard/orders",
    name: "Order History",
  },
  {
    url: "/user/dashboard/reviews/reviews-list",
    name: "Reviews",
  },
  {
    url: "/user/dashboard/privacy-settings",
    name: "Privacy Settings",
  },
];
